import { api as storageApi } from './auto-generated/storage'
import { api as revisionApi } from './auto-generated/revision'

storageApi.enhanceEndpoints({
  endpoints: {},
})

export { storageApi }
